import { ChangeEvent, forwardRef } from "react"
import { Input } from "@gogoro/go-design"
import { ReactComponent as CorrectComponent } from "assets/images/check-circle.svg"
import { ReactComponent as ErrorComponent } from "assets/images/close-circle.svg"
import classnames from "classnames"

import { TextInputProps } from "./TextInputProps"

import styles from "./styles.module.scss"

const TextInput = (
  { name, onChange = () => {}, showValidatedResultIcon, error, disabled, ...restProps }: TextInputProps,
  ref: any,
) => {
  const ValidatedResultIcon = error ? ErrorComponent : CorrectComponent

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    onChange(value, e)
  }

  return (
    <div className={classnames(styles["input-container"], { [styles["error"]]: error })}>
      <Input name={name} onChange={handleOnChange} disabled={disabled} ref={ref} {...restProps} />
      {showValidatedResultIcon && (
        <div className={classnames(styles["icon-container"], { [styles["disabled"]]: disabled })}>
          <ValidatedResultIcon role="img" className={error ? styles["error-icon"] : styles["checked-icon"]} />
        </div>
      )}
    </div>
  )
}

export default forwardRef(TextInput)
